import { FC } from 'react';

import Accordion from '@chewy/cms-accordion';
import Banner from '@chewy/cms-banner';
import ContentBlock from '@chewy/cms-content-block';
import Educational from '@chewy/cms-educational';
import HpHeroCarousel from '@chewy/cms-hp-hero-carousel';
import NonSku from '@chewy/cms-non-sku';
import SitewideBanner from '@chewy/cms-sitewide-banner';
import Sku from '@chewy/cms-sku';

import {
  CmsDataType,
  CmsUniversalProps,
} from '@src/pages/landing/components/cms/cms.types';

export const CmsUniversal: FC<CmsUniversalProps> = ({
  data,
  options,
  ...props
}) => {
  const getComponent = () => {
    switch (data.type) {
      case CmsDataType.Accordion:
        return <Accordion data={data} {...props} {...options?.accordion} />;
      case CmsDataType.Banner:
        return <Banner data={data} {...props} {...options?.banner} />;
      case CmsDataType.ContentBlock:
        return (
          <ContentBlock data={data} {...props} {...options?.contentBlock} />
        );
      case CmsDataType.BannerCarousel:
        return (
          <HpHeroCarousel data={data} {...props} {...options?.hpHeroCarousel} />
        );
      case CmsDataType.Card:
        return <Educational data={data} {...props} {...options?.educational} />;
      case CmsDataType.NonSku:
        return <NonSku data={data} {...props} {...options?.nonSku} />;
      case CmsDataType.SiteWideBanner:
        return (
          <SitewideBanner data={data} {...props} {...options?.sitewideBanner} />
        );
      case CmsDataType.Sku:
        return <Sku data={data} {...props} {...options?.sku} />;
      default:
        return <></>;
    }
  };

  return getComponent();
};
